// src/components/ApiKeys/RequestsDrawer.jsx
// Drawer lateral com o log de uso (api_requests) de uma chave, paginado.
import React, { useCallback, useEffect, useState } from 'react';
import apiUser from '../../apiUser';
import Loader from '../Loader/load';
import BaseButton from '../General/FormsComp/Button/BaseButton';

const LIMIT = 50;

const corStatus = (status) => {
  if (status >= 200 && status < 300) return 'text-green-600 dark:text-green-400';
  if (status === 429) return 'text-yellow-600 dark:text-yellow-400';
  return 'text-red-600 dark:text-red-400';
};

const RequestsDrawer = ({ chave, onClose }) => {
  const [requests, setRequests] = useState([]);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [fim, setFim] = useState(false); // pagina veio incompleta => nao ha proxima

  const carregar = useCallback(async (p) => {
    setLoading(true);
    try {
      const response = await apiUser.get(`/apikeys/${chave.id}/requests`, {
        params: { page: p, limit: LIMIT },
      });
      const { success, dados } = response.data;
      if (success) {
        setRequests(dados);
        setFim(dados.length < LIMIT);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }, [chave.id]);

  useEffect(() => { carregar(page); }, [page, carregar]);

  return (
    <div className="fixed inset-0 z-50">
      <div className="fixed inset-0 bg-black bg-opacity-50" onClick={onClose} />
      <div className="absolute right-0 top-0 h-full w-full max-w-2xl bg-white dark:bg-gray-800 shadow-2xl flex flex-col">
        <div className="px-6 py-4 border-b border-gray-200 dark:border-gray-700 flex items-center justify-between">
          <div>
            <h2 className="text-lg font-bold text-gray-900 dark:text-white">Requests — {chave.nome}</h2>
            <div className="text-xs text-gray-500 dark:text-gray-400"><code>{chave.key_prefix}…</code></div>
          </div>
          <BaseButton variant="ghost" size="sm" onClick={onClose}>Fechar</BaseButton>
        </div>
        <div className="flex-1 min-h-0 overflow-auto p-4">
          {loading ? (
            <Loader />
          ) : requests.length === 0 ? (
            <p className="text-sm text-gray-500 dark:text-gray-400 text-center py-8">
              Nenhum request nesta página.
            </p>
          ) : (
            <table className="w-full text-xs">
              <thead>
                <tr className="text-left text-gray-500 dark:text-gray-400">
                  <th className="py-1 pr-2">Quando</th>
                  <th className="py-1 pr-2">Método</th>
                  <th className="py-1 pr-2">Endpoint</th>
                  <th className="py-1 pr-2">Status</th>
                  <th className="py-1">IP</th>
                </tr>
              </thead>
              <tbody>
                {requests.map((r) => (
                  <tr key={r.id} className="border-t border-gray-100 dark:border-gray-700 text-gray-800 dark:text-gray-200">
                    <td className="py-1 pr-2 whitespace-nowrap">{new Date(r.created_at).toLocaleString('pt-BR')}</td>
                    <td className="py-1 pr-2 font-mono">{r.metodo}</td>
                    <td className="py-1 pr-2 font-mono break-all">{r.endpoint}</td>
                    <td className={`py-1 pr-2 font-semibold ${corStatus(r.status)}`}>{r.status}</td>
                    <td className="py-1 font-mono">{r.ip}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
        <div className="px-6 py-3 border-t border-gray-200 dark:border-gray-700 flex items-center justify-between">
          <BaseButton variant="ghost" size="sm" disabled={page === 1 || loading} onClick={() => setPage((p) => p - 1)}>
            Anterior
          </BaseButton>
          <span className="text-xs text-gray-500 dark:text-gray-400">Página {page}</span>
          <BaseButton variant="ghost" size="sm" disabled={fim || loading} onClick={() => setPage((p) => p + 1)}>
            Próxima
          </BaseButton>
        </div>
      </div>
    </div>
  );
};

export default RequestsDrawer;
